/**
 * FreeSpinsIntroOutroView
 *
 * Handles the view functionality of the free spins dialog(s)
 */
(function () {
  class FreeSpinsIntroOutro extends PIXI.Container {
    constructor() {
      super();

      this._callback = undefined;

      this.visible = false;

      //Intro Panel
      this._fsPanelBacking = undefined;
      this._youHaveWonText = undefined;
      this._spinsWon = undefined;
      this._freeSpinsText = undefined;

      //Outro Panel
      this._fsOutroPanelBacking = undefined;
      this._cashWon = undefined;
      this._fromFreeSpinsText = undefined;
      this._congratulationsText = undefined;
      this.betterLuckText = undefined;
      this._youHaveWonFsWinningsText = undefined;

      this._pressStartBox = undefined;
      this._introActive = false;

      this._dialogShowing = false;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._burst = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:Burst");
      this._burst.visible = false;
      this._gambleBacker = resourceManager.get("gambleBacker");
      this._fullPanel = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro");

      //Intro Panel
      this._fsPanelBacking = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:fsPanelBacking");
      this._fsPanelBacking.visible = false;

      this._youHaveWonText = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:youHaveWonText");
      this._youHaveWonText.visible = false;

      this._spinsWon = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:numFreeSpinsText");
      this._spinsWon.visible = false;

      this._freeSpinsText = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:freespinsText");
      this._freeSpinsText.visible = false;

      //Outro Panel
      this._fsOutroPanelBacking = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:fsOutroPanelBacking"
      );
      this._fsOutroPanelBacking.visible = false;

      this._cashWon = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:cashWonText");
      this._cashWon.visible = false;

      this._fromFreeSpinsText = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:fromFreespinsText"
      );
      this._fromFreeSpinsText.visible = false;

      this._congratulationsText = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:congratulationsText"
      );
      this._congratulationsText.visible = false;

      this.betterLuckText = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:betterLuck");
      this.betterLuckText.visible = false;

      this._youHaveWonFsWinningsText = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:youHaveWonFsWinningsText"
      );
      this._youHaveWonFsWinningsText.visible = false;

      this._pressStartBox = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:pressStartColourBox");

      this._pressStartBox.alpha = 0;
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;
    }

    setup() {
      this._pressStartBox.visible = true;
      this._pressStartBox.alpha = 0;
    }

    doBurst() {
      this._burst.visible = true;

      this.pulseTween = gsap.fromTo(
        this._burst.scale,
        {
          x: 1,
          y: 1,
        },
        {
          paused: true,
          delay: 0,
          duration: 0.5,
          x: 1.2,
          y: 1.2,
          yoyo: true,
          repeat: -1,
        }
      );
      this.pulseTween.time(0).restart(true);

      this._burst.rotation = 0;

      this.rotateTween = gsap.to(this._burst, {
        delay: 0,
        duration: 6,
        rotation: Math.PI * 2,
        ease: "linear",
        repeat: -1,
      });
      this.rotateTween.time(0).restart(true);
    }

    stopBurst() {
      this.pulseTween.time(0).restart(false);

      this.rotateTween.time(0).restart(false);

      this._burst.visible = false;
    }

    showIntro(numFS, callback) {
      soundManager.play("free_spins_intro");
      gameController.canSkipWin = false;
      this._introActive = true;
      this.setup();
      this.showCounters(false);
      this.fadeIn(this._gambleBacker, 0.8, 1.0, 0.0);

      this._callback = callback;

      //Intro Panel
      this._fsPanelBacking.visible = true;
      this._youHaveWonText.visible = true;
      this._spinsWon.visible = true;
      this._freeSpinsText.visible = true;
      this.doBurst();

      //Outro Panel
      this._fsOutroPanelBacking.visible = false;
      this._cashWon.visible = false;
      this._fromFreeSpinsText.visible = false;
      this._congratulationsText.visible = false;
      this.betterLuckText.visible = false;
      this._youHaveWonFsWinningsText.visible = false;

      this._spinsWon.text = numFS;

      this.floatIn(this._fullPanel, 0, 3);
      this.fadeIn(this._fullPanel, 1.0, 1.0, 0);

      musicManager.onFreespinsIntro();

      let self = this;
      timerManager.addTimeout(1500, function () {
        self.setActive();
      });

      soundManager.play("dialogIn");
    }

    floatIn(object, delay, duration) {
      gsap.fromTo(
        object,
        {
          x: 0,
          y: 500,
        },
        {
          delay,
          duration,
          ease: "elastic.out(1.0, 0.3)",
          x: 0,
          y: 0,
          onStart: () => {
            this._fullPanel.visible = true;
          },
        }
      );
    }

    fadeIn(object, alpha, duration, delay) {
      gsap.fromTo(
        object,
        {
          alpha: 0,
        },
        {
          delay: delay,
          duration: duration,
          alpha: alpha,
          onStart: () => {
            object.visible = true;
          },
        }
      );
    }

    bounceIn(object, delay, duration, scale) {
      gsap.fromTo(
        object.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: delay,
          duration: duration ?? 1,
          ease: "Bounce.easeOut",
          x: scale ?? 1,
          y: scale ?? 1,
          onStart: () => {
            object.visible = true;
            object.alpha = 1;
          },
          onComplete: () => {
            this.setActive();
          },
        }
      );
    }

    setActive() {
      this._dialogShowing = true;
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = this.closeDialog.bind(this);

      const sp = gdk.getServerParser();
      const inReplayOrRewatch = sp._inReplayMode || sp._inRewatchMode;

      if (inReplayOrRewatch) {
        timerManager.delayAsync(5000, undefined, () => {
          if (this._dialogShowing) {
            this.closeDialog();
          }
        });
      }
    }

    showCounters(show) {
      const cloverCountContainer = resourceManager.get("postReels:rapidRespinsContainer");
      const coinCountMeter = resourceManager.get("postReels:CoinCounterContainer:coinCollectMeter");
      const counCountFill = resourceManager.get("postReels:CoinCounterContainer:coinCollectFillContainer");
      //const coinCountFont = resourceManager.get("postReels:CoinCounterContainer:coinCollectMeterFont");
      cloverCountContainer.visible = show;
      coinCountMeter.visible = show;
      counCountFill.visible = show;
      //coinCountFont.visible = show;
    }

    showOutro(cashWon, callback) {
      // musicManager.onPlayBubbleIntro();
      gameController.canSkipWin = false;
      gameController.canSlamStop = false;

      this.fadeIn(this._gambleBacker, 0.8, 1.0, 0.0);

      this._introActive = false;
      this._fullPanel.visible = true;
      this.setup();
      this.showCounters(true);

      this._callback = callback;

      //Intro Panel
      this._fsPanelBacking.visible = false;
      this._youHaveWonText.visible = false;
      this._spinsWon.visible = false;
      this._freeSpinsText.visible = false;

      //Outro Panel
      this._fsOutroPanelBacking.visible = true;
      this._cashWon.visible = true;
      this._fromFreeSpinsText.visible = true;
      this.doBurst();

      this._youHaveWonFsWinningsText.visible = true;

      if (cashWon === 0) {
        this.betterLuckText.visible = true;
      } else {
        this._congratulationsText.visible = true;
      }

      this.floatIn(this._fullPanel, 0, 3);
      this.fadeIn(this._fullPanel, 1.0, 1.0, 0);

      soundManager.play("free_spins_end");

      let self = this;
      timerManager.addTimeout(1500, function () {
        self.setActive();
      });

      this._cashWon.setText(gdk.formatCurrency(cashWon));
    }

    closeDialog() {
      this._dialogShowing = false;
      let reels = resourceManager.get("slotContainer:reelContainer");
      reels.alpha = 1.0;
      // turn off click processing
      this._pressStartBox.visible = false;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = undefined;

      soundManager.play("buttonPressV1");

      soundManager.play("dialogOut");

      if (this._introActive) {
        soundManager.play("clickToContinueStartFS");
        this.clearIntro();
      } else {
        soundManager.play("clickToContinueEndFS");
        this.clearOutro();
      }
    }

    clearIntro() {
      let self = this;

      this.fadeOut(this._gambleBacker, 1.0);
      this.riseUp(this._fullPanel, 1.0);

      timerManager.addTimeout(1000, function () {
        self._callback();
      });
    }

    clearOutro() {
      let self = this;

      this.fadeOut(this._gambleBacker, 1.0);
      this.riseUp(this._fullPanel, 1.0);

      timerManager.addTimeout(500, function () {
        self._callback();
      });
    }

    fadeOut(object, duration) {
      gsap.to(object, {
        duration: duration,
        alpha: 0,
        ease: "power1.in",
        onComplete: () => {
          object.visible = false;
          object.alpha = 1;
        },
      });
    }

    riseUp(object, duration, cb) {
      const originalPosition = {
        x: gsap.getProperty(object, "x"),
        y: gsap.getProperty(object, "y"),
      };

      gsap.to(object, {
        duration: duration,
        x: 0,
        y: -1000,
        ease: "power4.in",
        onComplete: () => {
          object.visible = false;
          gsap.set(object, { x: originalPosition.x, y: originalPosition.y });
          if (cb) {
            cb();
          }

          this.stopBurst();
        },
      });
    }
  }

  let freeSpinsIntroOutroCreator = function (json) {
    return new FreeSpinsIntroOutro();
  };

  let freeSpinsIntroOutroInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  let freeSpinsIntroOutroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "FreeSpinsIntroOutro",
    freeSpinsIntroOutroCreator,
    freeSpinsIntroOutroInitialiser,
    freeSpinsIntroOutroFilesRequired
  );
})();
